import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const BASE_I18N_KEY = 'learningCenter.practicalExercise.retryModal';
const RetakePracticalExerciseModal = ({
  onConfirm,
  onReject
}) => /*#__PURE__*/_jsx(ConfirmModal, {
  confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    "data-test-id": "practical-exercise-retake-modal-ok",
    message: `${BASE_I18N_KEY}.confirmLabel`
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${BASE_I18N_KEY}.description`
  }),
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${BASE_I18N_KEY}.message`
  }),
  onConfirm: onConfirm,
  onReject: onReject,
  rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${BASE_I18N_KEY}.rejectLabel`
  })
});
export default RetakePracticalExerciseModal;